// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1_4Sz","title":"FrontImage_title__1mRVv"};